import { IHttpApi, IModel, IModelResponse } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

const defaultConfig: TSwitchToHomeownerModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  method: 'POST',
  microserviceName: 'homeowners',
  pathApi: '/v1/set-as-homeowner/',
};

export type TSwitchToHomeownerModel = IModel<ISwitchToHomeownerRequest, ISwitchToHomeownerResponse>;

export interface ISwitchToHomeownerRequest {
  locationPath?: string;
}

export interface ISwitchToHomeownerResponseSchema {
}

export interface ISwitchToHomeownerResponse extends IModelResponse<ISwitchToHomeownerResponseSchema> {
  Code: 200;
}

export function createModel(config: Partial<TSwitchToHomeownerModel>): TSwitchToHomeownerModel {
  return {
    ...defaultConfig,
    ...config,
  };
}

export interface ISwitchToHomeownerDependencies {
  logger: ILogger;
  httpApi: IHttpApi;
}

export const switchToHomeowner = async (
  dependencies: ISwitchToHomeownerDependencies,
  parameters?: ISwitchToHomeownerRequest,
) => {
  const { httpApi, logger } = dependencies;

  const requestConfig = {
    withCredentials: true,
    headers: [[ 'Content-Type', 'application/json' ]] as [string, string][],
  };

  try {
    const { response } = await httpApi.fetch(createModel({ parameters }), { requestConfig });

    return response;
  } catch (error) {
    logger.error(
      error,
      {
        description: 'Homeowners v1/set-as-homeowner rejection error',
        requestParameters: { ...parameters },
      },
    );

    return Promise.resolve({ data: { } });
  }
};
